import React, { Component } from 'react'
import firebase from 'firebase'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'

import * as manageEducatorsActionCreators from '../../redux/modules/manageEducators'
import { db } from '../../config/firebaseconfig'
import { ManageEducators, } from '../../components'
import initializeManageEducators from '../../helpers/users/initializeManageEducators'
import getSelection from '../../helpers/users/getSelection'
import getParentId from '../../helpers/users/getParentId'
import has from 'mout/object/has'

import superAdminUser from '../../helpers/users/testing/superAdminUser' // Testing
import districtAdmin from '../../helpers/users/testing/districtAdmin'
import forceSelectionByRole from '../../helpers/users/forceSelectionByRole';
import getSchoolYear from '../../helpers/getSchoolYear'
import determineSchoolYear from '../../helpers/determineSchoolYear'
import { setIndicator } from '../../redux/modules/assessmentIndicator'
import { BeatLoader } from 'react-spinners'


/*

  Manage Password proptype failure checkbox

  Limit functionality for what role is signed in (views per role)

  String up UI

  Make sure no duplicates of email addresses or usernames!!!!!!
  Have to handle deleting schools, districts, etc. (warning, plus ripple down to all affected schools, students, etc.)

  Clean up registration and log-in in database.
  (Assume that we'll soon get the secure auth going using tokens)


  Phone number
  Kill amcharts react to eliminate compile issues and create own components using library

*/

class ManageEducatorsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      forceDistrictExpanded: false,
      forceSchoolExpanded: false,
      forceTeacherExpanded: false,
      districtNameSearch: '',
    }

    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.select = this.select.bind(this)
    this.setForceDistrictExpanded = this.setForceDistrictExpanded.bind(this)
    this.setSearch = this.setSearch.bind(this)
    this.setForceExpanded = this.setForceExpanded.bind(this)
    this.deleteRecord = this.deleteRecord.bind(this)
    this.schoolYearDataIndicator = this.schoolYearDataIndicator.bind(this)
  }



  componentDidMount() {
    /*
      Hardwired the active user for testing
    */
    this.user = this.props.testUser || districtAdmin
    //    this.user = districtAdmin
    const initActions = {
      initializing: this.props.initializing,
      initializingError: this.props.initializingError,
      initializingSuccess: this.props.initializingSuccess,
      set: {
        districts: this.props.setDistricts,
        schools: this.props.setSchools,
        educators: this.props.setEducators,
        students: this.props.setStudents,
        classes: this.props.setClasses,
      }
    }
    initializeManageEducators(this.user, initActions, this.props.match.params)

  }

  setSearch(searchProp, e) {
    this.setState({ [searchProp]: e.target.value })
  }

  closeModal(id) {
    if (!id) {
      this.props.history.push('?')
    } else if (!(typeof id === 'string' || id instanceof String)) {
      this.props.history.push('?')
    } else {
      this.props.history.push(`/users/educators/${id}`)
    }
  }

  openModal(modal) {
    this.props.history.push(`?m=${modal}`)
  }

  select(id) {
    this.props.history.push(`/users/educators/${id}`)
    if (this.props.districts[id]) {
      this.setState({ forceDistrictExpanded: false })
    }
    if (this.props.schools[id]) {
      this.setState({
        forceDistrictExpanded: false,
        forceSchoolExpanded: false
      })
    }
    if (this.props.educators[id]) {
      this.setState({
        forceDistrictExpanded: false,
        forceSchoolExpanded: false,
        forceTeacherExpanded: false,
      })
    }
  }

  setForceExpanded(key, val) {
    this.setState({ [key]: val })
  }

  setForceDistrictExpanded(forceDistrictExpanded) {
    this.setState({ forceDistrictExpanded, })
  }

  deleteRecord(collectionName, id) {
    this.props.deletingRecord()
    const data = {
      districts: this.props.districts,
      schools: this.props.schools,
      educators: this.props.educators,
      classes: this.props.classes,
    }
    let selectionId
    let match = false
    if (this.props.match.params.activeSelection === id) {
      match = true
      selectionId = getParentId(id, data)
    }
    db.collection(collectionName).doc(id).update({ deleted: true })
      .then(() => {
        this.props.deletingRecordSuccess()
        if (selectionId && match) {
          this.props.history.push(`/users/educators/${selectionId}`)
        } else if (match) {
          this.props.history.push(`/users/educators`)
        } else {
          this.closeModal()
        }
      })
      .catch((err) => this.props.deletingRecordError(err))
  }

  schoolYearDataIndicator(data){
    const years = data.map((year) => determineSchoolYear(year.created))
    const noDublicates = new Set([...years]);
    let options = [...noDublicates].sort((a, b) => b.split('sy')[1] - a.split('sy')[1]).map((year) => {
      let currentYear = Number(year.split('sy')[1])
      let nextYear = currentYear + 1
      return {
        value: year,
        year: year,
        label: `School Year: [${currentYear + "-" + nextYear}]`
      }
    })

    this.props.setIndicator({
      selectOptions: [...options],
      defaultValue: options[0],
      selectedOption: options[0]
    })
  }

  componentWillUnmount(){
    this.props.setIndicator({
      selectOptions: [],
      defaultValue: {},
      selectedOption: {}
    })
  }

  render() {
    let modal = ''
    let recordId = ''
    if (this.props.location.search) {
      const query = queryString.parse(this.props.location.search)
      if (query.m) {
        modal = query.m
      }
      if (query.id) {
        recordId = query.id
      }
    }

    let selection
    if (has(this.props, 'match.params.activeSelection') && this.props.districts && this.props.schools) {
      const data = {
        districts: this.props.districts,
        schools: this.props.schools,
        educators: this.props.educators,
        classes: this.props.classes,
      }
      selection = getSelection(this.props.match.params.activeSelection, data)
      this.user ? selection = forceSelectionByRole(this.user, selection) : null
    } else {
      selection = {
        district: '',
        school: '',
        teacher: '',
        class: '',
      }
      this.user ? selection = forceSelectionByRole(this.user, selection) : null
    }
    const { districts, schools, educators, students } = this.props

    return (districts && schools && educators && students ? 
      <ManageEducators
        isInitializing={this.props.isInitializing}
        isInitializingError={this.props.isInitializingError}
        districts={this.props.districts}
        schools={this.props.schools}
        educators={this.props.educators}
        classes={this.props.classes}
        students={this.props.students}
        user={this.user}
        selection={selection}
        modal={modal}
        openModal={this.openModal}
        closeModal={this.closeModal}
        select={this.select}
        forceDistrictExpanded={this.state.forceDistrictExpanded}
        setForceDistrictExpanded={this.setForceDistrictExpanded}
        filters={this.props.filters}
        districtNameSearch={this.state.districtNameSearch}
        setFilter={this.props.setFilter}
        setSearch={this.setSearch}
        setForceExpanded={this.setForceExpanded}
        forceSchoolExpanded={this.state.forceSchoolExpanded}
        forceTeacherExpanded={this.state.forceTeacherExpanded}
        recordId={recordId}
        deleteRecord={this.deleteRecord}
        isDeleting={this.props.isDeleting}
        isDeletingError={this.props.isDeletingError}
        year={this.props.selectedYear ? this.props.selectedYear : getSchoolYear().year}
        schoolYearDataIndicator={this.schoolYearDataIndicator}
      /> : <BeatLoader loading={true} />
    )
  }
}

export default connect(
  (state) => ({
    isInitializing: state.manageEducators.isInitializing,
    isInitializingError: state.manageEducators.error,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    selection: state.manageEducators.selection,
    filters: state.manageEducators.filters,
    isDeleting: state.manageEducators.isDeleting,
    isDeletingError: state.manageEducators.isDeletingError,
    testUser: state.users.testUser,
    selectedYear: state.users.selectedYear,
    assessmentIndicator: state.assessmentIndicator,
  }),
  (dispatch) => bindActionCreators({ ...manageEducatorsActionCreators, setIndicator }, dispatch)
)(ManageEducatorsContainer)


// WEBPACK FOOTER //
// ./src/containers/Users/ManageEducatorsContainer.js